import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getAudits as getAuditsApi,
  getAuditById as getAuditByIdApi,
} from '../../helpers/bff_helper';

export const getAudits = createAsyncThunk(
  'audits/getAudits',
  async (params) => {
    params.order = 'desc';
    params.page = params.page || 1;
    try {
      const response = getAuditsApi(params);

      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getAuditById = createAsyncThunk(
  'audits/getAuditById',
  async (id) => {
    try {
      return getAuditByIdApi(id);
    } catch (error) {
      return error;
    }
  }
);

